import React from 'react';

export function useMatchesMinWidth(minWidth) {
  const doesMediaMatches = React.useCallback(() => {
    return window.matchMedia(`(min-width: ${minWidth}px)`).matches;
  }, [minWidth]);
  const [matches, setMatches] = React.useState(doesMediaMatches());
  const onResize = React.useCallback(() => setMatches(doesMediaMatches()), [
    matches,
  ]);
  React.useEffect(() => {
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [minWidth]);
  return matches;
}
